import {
  normalizeRecipeSiteOrigin,
  parseRecipeReturn,
  type RecipeReturn,
} from './recipe-links';

export type AppMode = 'app' | 'demo';

export interface AppRuntime {
  mode: AppMode;
  databaseName: string;
  appPath: string;
  demoPath: string;
  recipeSiteOrigin: string | null;
  recipeReturn: RecipeReturn | null;
}

const APP_DATABASE = 'inventaire-congelateurs';
const DEMO_DATABASE = 'frozen-save-public-demo-v1';

export const resolveAppRuntime = (
  url: URL,
  recipeSiteOrigin?: string,
): AppRuntime => {
  const explicitMode = url.searchParams.get('mode');
  const mode: AppMode =
    url.pathname === '/demo' || url.pathname.startsWith('/demo/') || explicitMode === 'demo'
      ? 'demo'
      : 'app';

  return {
    mode,
    databaseName: mode === 'demo' ? DEMO_DATABASE : APP_DATABASE,
    appPath: '/',
    demoPath: '/demo',
    recipeSiteOrigin: normalizeRecipeSiteOrigin(recipeSiteOrigin),
    recipeReturn: parseRecipeReturn(url),
  };
};

export const currentAppRuntime = (): AppRuntime =>
  resolveAppRuntime(
    new URL(window.location.href),
    import.meta.env.VITE_RECIPE_SITE_ORIGIN,
  );

export const applySearchIndexingPolicy = (
  runtime: Pick<AppRuntime, 'mode'>,
  targetDocument: Document = document,
): void => {
  const content = runtime.mode === 'demo'
    ? 'noindex, nofollow, noarchive'
    : 'index, follow';

  for (const name of ['robots', 'googlebot']) {
    let meta = targetDocument.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (meta == null) {
      meta = targetDocument.createElement('meta');
      meta.name = name;
      targetDocument.head.append(meta);
    }
    meta.content = content;
  }
};
